/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentPlatformRepresentation } from '@veeam-vspc/models/web-controllers';

export type VawPlatformTypes = BackupAgentPlatformRepresentation;
export const VawPlatformTypes = BackupAgentPlatformRepresentation;
